import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FlashController} from "../../../../flash-payment-core/services/flash-controller.service";

@Component({
  selector: 'app-dialog-continue',
  templateUrl: './dialog-continue.component.html',
  styleUrls: ['./dialog-continue.component.sass']
})
export class DialogContinueComponent implements OnInit {
  data;
  showCancel = true;
  message = '';
  step = 0;
  constructor(
    private flashController: FlashController,
    public dialogRef: MatDialogRef<DialogContinueComponent>
  ) {}

  ngOnInit(): void {
    this.data = this.flashController.controller.cardSelected;
    this.message = `¿Deseas realizar el pago con la tarjeta ${this.data.franchiseName}  XXXX-XXXX-XXXX-${this.data.lastFourDigits}?`;
  }

  ok() {
    if (this.data.franchiseName.toString().toLowerCase().includes('ath')) {
      this.flashController.achProcess();
      this.dialogRef.close();
    } else {
      this.message = 'Introduzca el CCV de su tarjeta para continuar.';
      this.step+=1;
    }

  }

  cancel() {
    this.dialogRef.close();
  }

  verifyProcess() {
    if (this.flashController.controller.ccv) {
      this.flashController.pay();
      this.dialogRef.close();
    } else {
      this.message = 'El CCV es un campo obligatorio para poder continuar';
    }
  }

}
